<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('blog.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">
              {{$t('blog.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-4">
    <div class="row" v-if="isLoading">
      <div class="col text-center">
        <mainloader />
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <div class="row">
          <div class="col-12 col-lg-4 py-3" v-for="(row, index) in rows" :key="index">
            <router-link :to="'/blogDetails/'+row.id">
              <div class="card card-border">
                <div class="card-body">
                  <div class="bg-Image">
                    <img :src="MEDIA_URL+row.image" class="bg-Image  blog_image" alt="">
                  </div>
                  <div>
                    <div class="p_Title">{{row.title}}</div>
                    <p class="fonttext-14">{{row.subject.slice(0,80)}}</p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row pt-5">
          <div class="col">
            <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-center mouse-hand">
                <li class="page-item pagination-padding page-link br-radius4" v-if="currentPage > 1"  @click.prevent="prevPage">
                  <i class="fa-solid fa-circle-right orange-color mx-2"></i>
                  <span>{{$t('prev')}}</span>
                </li>
                <li class="page-item pagination-style">{{currentPage}}</li>
                <li class="page-item page-link pagination-padding br-radius4" v-if="rows && rows.length >= 30"  @click.prevent="nextPage">
                  <span class="mx-2">{{$t('next')}}</span>
                  <i class="fa  -solid fa-circle-left orange-color"></i>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'blog',
  data(){
    return {
      hasError: false,
      errorNumber: 0,
      message: "",
      isLoading: true,
      rows: [],
      currentPage: 1,
      userLang: 'ar',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    getData(){
      this.hasError = false;
      this.$http.get("/api/forums/list?page="+this.currentPage).then(res => {
        // console.log(res);
        this.rows = res.data.rows;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = false;
      });
    },

    prevPage(){
      this.currentPage -= 1;
      this.getData();
    },

    nextPage(){
      this.currentPage += 1;
      this.getData();
    }
  },
  created(){
    this.getData();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>